import {
	type Task,
	type ProjectPhase,
	type TaskListLimitedTaskFragment,
	type TaskListTaskFragment,
} from '@/generated/graphql';
import { type ValueOf } from '@/types';
import {
	type SuiDataTableColumnType,
	type SuiDataTableSortDirection,
} from '@developers/scoro-ui';
import { type UNGROUPED_TASKS_ID } from './constants';

export enum TaskListGroupBy {
	Phases = 'phases',
	None = 'none',
}

export type SortState = {
	columnId: SuiDataTableColumnType['id'];
	direction: ValueOf<typeof SuiDataTableSortDirection>;
};

export type TaskListLoadingRows = Record<
	ProjectPhase['id'] | typeof UNGROUPED_TASKS_ID,
	string[]
>;

export type TaskListLoadingSubtaskRows = Record<Task['id'], string[]>;

export const TaskBundlePlacement = {
	Top: 'top',
	Bottom: 'bottom',
} as const;

export type TasListTaskOrLimited =
	| TaskListLimitedTaskFragment
	| TaskListTaskFragment;

export interface CellDefinition {
	columnId: string;
	align?: 'left' | 'right' | 'center';
	isNumber?: boolean;
}
